import { EConfigurableTableFields } from "libraries/pipes/configurable-table/compute-value.pipe";

export interface IConfigurableTable {
    isVisibleHeader?: boolean;
    defaultSortArray?: IConfigurableTableDefaultSort[];
    columnArray?: IConfigurableTableColumn[];
}

export enum EOrder {
    ascending = "ascending",
    descending = "descending",
}

export interface IConfigurableTableDefaultSort {
    fieldKey?: string;
    order?: EOrder ;
}

export interface IConfigurableTableColumn {
    key?: string;
    defaultLabel?: string;
    fieldKeyArray?: string[];
    isDisplayed?: boolean;
}

export interface IConfigurableTableColumnHmpr extends IConfigurableTableColumn {
    fieldKeyArray?: EConfigurableTableFields[];
}

export interface IConfigurableTableHmpr extends IConfigurableTable {
    columnArray?: IConfigurableTableColumnHmpr[];
}
